import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { fetchBalance, logout } from 'stores/auth';
import Language from '../../layout/_components/Language';
import { AWS_BUCKET_URL } from '../../toolkit/constants';
import { removeAllBetSlip } from 'stores/betSlip';
import { BsQrCodeScan, BsGlobe } from 'react-icons/bs';
import { useMediaQuery } from 'react-responsive';
import useCurrency from 'toolkit/useHooks/useCurrency';
import RefundBonusCard from './RefundBonusCard';

export default function Profile(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation('translations');
  const navigate = useNavigate();
  const { onClose } = props;
  const balance = useSelector((state) => state.auth.balance);
  const refundBonusBalance = useSelector((state) => state.auth.refundBonusBalance);
  const user = useSelector((state) => state.auth.user);
  const { sign: currencySign } = useCurrency();
  const showQrDeposit = user?.qrEnabled === true;
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)'
  });

  useEffect(() => {
    dispatch(fetchBalance());
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    dispatch(removeAllBetSlip());
    onClose();
    navigate('/');
  };

  return (
    <Container fluid>
      <Card className="mb-3">
        <Card.Body>
          <Row className="align-items-center h6">
            <Col xs={7} className="d-flex align-items-center">
              <div className="me-3">
                <img size={24} src={`${AWS_BUCKET_URL}/Icons/58.png`} />
              </div>
              <div className="">
                <h1 className="display-6 fs-7 fw-bold mb-1">{user.username}</h1>
                <h1 className="display-6 fs-7 text-muted mb-0">{user.email}</h1>
              </div>
            </Col>
            <Col xs={5} className="text-end">
              <div className={`badge h5 text-end bg-${balance > 0 ? 'success' : 'danger'}`}>
                {balance.toLocaleString('de-DE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' ' + currencySign}
              </div>
              <br></br>
              <div
                className={`badge h5 text-end bg-${refundBonusBalance > 0 ? 'primary' : 'danger'}`}>
                {user.isRefundBonusEnabled &&
                  refundBonusBalance.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) + ' ' + currencySign}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <RefundBonusCard />
      <hr></hr>
      <Row className="h6 align-items-center">
        <Col xs={'auto'}>
          <img width="25" height="25" src={`${AWS_BUCKET_URL}/Icons/61.png`} />
        </Col>
        <Col xs={8}>
          <Link to={'/profilesettings'} className="text-primary" onClick={onClose}>
            {t('settings')}
          </Link>
        </Col>

        <Col xs={'auto'} className="ms-auto">
          <Link to={'/profilesettings'} className="float-end" onClick={onClose}>
            <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} />
          </Link>
        </Col>
      </Row>
      <hr></hr>
      <Row className="h6 align-items-center">
        <Col xs={'auto'}>
          <img width="25" height="25" src={`${AWS_BUCKET_URL}/Icons/62.png`} />
        </Col>
        <Col xs={8}>
          <Link to={'/changepassword'} className="text-primary" onClick={onClose}>
            {t('changepassword')}
          </Link>
        </Col>

        <Col xs={'auto'} className="ms-auto">
          <Link to={'/changepassword'} className="float-end" onClick={onClose}>
            <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} />
          </Link>
        </Col>
      </Row>
      <hr></hr>
      <Row className="h6 align-items-center">
        <Col xs={'auto'}>
          <img width="25" height="25" src={`${AWS_BUCKET_URL}/Icons/67.png`} />
        </Col>
        <Col xs={8}>
          <Link to={'/bettinghistory'} className="text-primary" onClick={onClose}>
            {t('bettinghistory')}
          </Link>
        </Col>

        <Col xs={'auto'} className="ms-auto">
          <Link to={'/bettinghistory'} className="float-end" onClick={onClose}>
            <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} />
          </Link>
        </Col>
      </Row>
      <hr></hr>
      <Row className="h6 mb-0 align-items-center">
        <Col xs={'auto'}>
          <img width="25" height="25" src={`${AWS_BUCKET_URL}/Icons/68.png`} />
        </Col>
        <Col xs={8}>
          <Link
            to={{
              pathname: `/transactions/${user.id}`
            }}
            className="text-primary"
            onClick={onClose}>
            {t('transaction')}
          </Link>
        </Col>
        <Col xs={'auto'} className="ms-auto">
          <Link
            to={{
              pathname: `/transactions/${user.id}`
            }}
            className="float-end"
            onClick={onClose}>
            <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} />
          </Link>
        </Col>
      </Row>
      <hr></hr>
      {showQrDeposit && (
        <>
          <Row className="h6 align-items-center">
            <Col xs={'auto'}>
              <BsQrCodeScan size={24} />
            </Col>
            <Col xs={8}>
              <Link to={'/qr-deposit'} className="text-primary" onClick={onClose}>
                {t('qrDeposit')}
              </Link>
            </Col>

            <Col xs={'auto'} className="ms-auto">
              <Link to={'/qr-deposit'} className="float-end" onClick={onClose}>
                <img width="20" height="20" src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`} />
              </Link>
            </Col>
          </Row>
          <hr className="my-1"></hr>
        </>
      )}
      <Row className="h6 align-items-center">
        <Col xs={'auto'}>
          <BsGlobe size={24} />
        </Col>
        <Col xs={7} className="text-primary">
          {t('language')}
        </Col>
        <Col xs={'auto'} className={`ms-auto my-n2 ${!isDesktop ? 'me-n5' : ''}`}>
          <Language />
        </Col>
      </Row>

      <hr className="my-1"></hr>
      {user === null ? (
        <Link to="/login" onClick={onClose}>
          <Row className="h6">
            <div className="container mt-3">
              <div className="row justify-content-center">
                <Button className="p-2 w-100 mt-2">Login</Button>
              </div>
            </div>
          </Row>
        </Link>
      ) : (
        <Row className="h6" onClick={() => handleLogout()}>
          <div className="container mt-3">
            <div className="row justify-content-center m-1">
              <Button className="p-2 m-2">Logout</Button>
            </div>
          </div>
        </Row>
      )}
    </Container>
  );
}
